import { AuthenticationResult } from "@azure/msal-browser";
import { ActionIcon, Box, Button, Divider, Paper, Text, TextInput, useMantineColorScheme } from "@mantine/core";
import { IconBrandWindowsFilled, IconMoon, IconSun } from "@tabler/icons-react";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { loginHandler } from "../utils/MsalAuthHandler";
import { msalInstance } from "../utils/MsalInstance";
import { userAuth } from "../utils/Authorization";

function Login() {
    const { colorScheme, setColorScheme } = useMantineColorScheme();
    const navigate = useNavigate();

    const colorSchemeToggle = () => {
        if (colorScheme === 'dark') {
            setColorScheme('light');
        } else {
            setColorScheme('dark');
        }
    };

    const rickRoll = () => {
        window.location.href = "https://www.youtube.com/watch?v=dQw4w9WgXcQ";
    };

    useEffect(() => {
        const bootstrap = async() => {
            const msalResponse: AuthenticationResult | null = await msalInstance.handleRedirectPromise();

            if (msalResponse !== null) {
                msalInstance.setActiveAccount(msalResponse.account);

                // Fetch user roles
                await userAuth.fetchUserRoles();

                navigate("/");
            }
        };

        bootstrap();
    }, [navigate]);

    return (
        <Box style={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
        }}>
            <Paper mb="16px" style={{
                display: "flex",
                minWidth: "430px",
                flexDirection: "column",
                alignItems: "center",
                padding: "48px",
                borderRadius: "16px",
                border: "1px solid var(--border-color)",
            }}>
                <Text size="38px" mb={"md"}>Sign in to Unify</Text>
                <Text size="14px" mb={"md"}>{process.env.REACT_APP_VERSION}</Text>

                {/* Wrap this in a form */}
                <TextInput w={"100%"} mb={"md"} placeholder="Email" type="email" />
                <TextInput w={"100%"} mb={"md"} placeholder="Password" type="password" />
                <Button className="unify-btn-primary" w={"100%"} mb={"md"} size="md" onClick={rickRoll}>Sign in</Button>

                <Divider w={"100%"} mb={"md"} label="Or sign in with" />

                <Button className="unify-btn-primary" w={"100%"} mb={"md"} size="md" onClick={loginHandler} leftSection={<IconBrandWindowsFilled />}>Microsoft</Button>
                <ActionIcon  className="unify-action-icon-subtle" onClick={colorSchemeToggle}>
                    {colorScheme === 'dark' ? <IconSun /> : <IconMoon />}
                </ActionIcon>
            </Paper>
            <Text size="14px" c="gray">Please contact your IT administrator to report any issues</Text>
        </Box>
    )
}

export default Login